import React from 'react';
import ReactDOM from 'react-dom';
import charWatchTrack from '../shared/CharWatchTrack';

class LcWatch extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default charWatchTrack(LcWatch, 'lc', 'watch');


// WEBPACK FOOTER //
// ./src/components/sections/lc/LcWatch.js